var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 800,
    rx: 400,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51404_1952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M437.616 401.286L583.248 232H548.738L422.285 378.988L321.288 232H204.8L357.527 454.273L204.8 631.795H239.312L372.849 476.57L479.509 631.795H595.998L437.607 401.286H437.616ZM390.347 456.231L374.872 434.097L251.747 257.98H304.756L404.119 400.112L419.594 422.246L548.754 606.996H495.745L390.347 456.239V456.231Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51404_1952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 391.198,
    height: 400,
    fill: "white",
    transform: "translate(204.8 232)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterSocial);
export default __webpack_public_path__ + "static/media/twitter-social.2c403b59bdc3317f7b7cadb83a2be834.svg";
export { ForwardRef as ReactComponent };